export default "__VITE_ASSET__9fec76a2__"